module.exports = __webpack_public_path__ + "static/media/image2.41ecb331.png";